import { useContext } from 'react';
import { NotesBoardContext } from '../context';

export function useBoardContext() {
  const context = useContext(NotesBoardContext);
  if (!context) {
    throw new Error('useBoardContext must be used within a NotesBoardProvider');
  }
  return context;
}
